import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { Observable, ReplaySubject } from 'rxjs';

import { LastUrlService, LoginUrl } from './last-url.service';
import { UserService } from '../../user/services/user.service';

@Injectable({
    providedIn: 'root'
})
export class LoggedInGuardService  {
    constructor(private router: Router, private userService: UserService, private authenticationService: AuthenticationService, private lastUrlService: LastUrlService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

        if (this.checkOldUrls(state.url)) {
            return Promise.resolve(false);
        }

        // Save the state-url to be used after a user has logged in.
        let routeURL = route.pathFromRoot.filter(p => p.url.length > 0).map(p => p.url.map(s => s.path).join('/')).join('/'); // Get full path of all route-elements.
        let loginUrl = new LoginUrl();
        loginUrl.path = routeURL;
        loginUrl.parms = route.params;
        this.lastUrlService.setLastUrl(loginUrl);

        return new Promise((resolve, reject) => {
            this.authenticationService.isLoggedIn().then(isLoggedIn => {
                if (!isLoggedIn) {
                    this.authenticationService.navigateToLogin();
                    resolve(false);
                }
                else {
                    resolve(true);
                }
            });
        });
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        return this.canActivate(route, state);
    }

    private checkOldUrls(url: string): boolean {

        // TRACKING SEARCH -> SHOW DOCUMENTS
        let trackingShowDocumentUrl = '/#/SearchShowDocument?documents=';
        if (url.indexOf(trackingShowDocumentUrl) >= 0) {
            let documentIds = url.substring(url.indexOf(trackingShowDocumentUrl) + trackingShowDocumentUrl.length);
            let documentIdArray = documentIds.split(';');
            this.router.navigate(['tracking/result/details', { documentIds: documentIdArray.join(',') }]);
            return true;
        }

        // DISTRIBUTIONS -> SHOW DISTRIBUTION
        let distributionShowDocumentUrl = '/#/DistributionSearchResultView?distributionId=';
        if (url.indexOf(distributionShowDocumentUrl) >= 0) {
            let distributionIds = url.substring(url.indexOf(distributionShowDocumentUrl) + distributionShowDocumentUrl.length);
            let distributionIdArray = distributionIds.split(';');
            this.router.navigate(['distribution/result/details', { distributionIds: distributionIdArray.join(',') }]);
            return true;
        }

        // DISTRIBUTIONS -> SHOW DISTRIBUTION
        let partnerShowDocumentUrl = '/#/PartnerView?partner=';
        if (url.indexOf(partnerShowDocumentUrl) >= 0) {
            let partnerIds = url.substring(url.indexOf(partnerShowDocumentUrl) + partnerShowDocumentUrl.length);
            let partnerIdArray = partnerIds.split(';');
            this.router.navigate(['partner/details', { partnerIds: partnerIdArray.join(',') }]);
            return true;
        }

        return false;
    }
}
